export const transformToLegacyPurchaseMotionsShape = (locations, evaluationResponse) => {
  const legacyPurchaseMotions = {};
  try {
    for (const location of locations) {
      const purchaseMotionsByApiName = {};
      const purchaseMotionsByProvidedLocation = evaluationResponse.purchaseMotionsMapping.productsByLocationString[location];
      for (const [apiName, purchaseMotionsForApiName] of Object.entries(purchaseMotionsByProvidedLocation.purchaseMotionsByProductApiName)) {
        purchaseMotionsByApiName[apiName] = purchaseMotionsForApiName.purchaseMotions.map(purchaseMotion => {
          return {
            key: purchaseMotion.toString()
          };
        });
      }
      legacyPurchaseMotions[location] = {
        purchaseMotions: purchaseMotionsByApiName
      };
    }
  } catch (error) {
    throw new Error(`Expected purchase motions not found for location: ${locations.join(', ')}`, {
      cause: error
    });
  }
  return legacyPurchaseMotions;
};